import { render } from "./IconSupport.vue?vue&type=template&id=278ee2f9&ts=true"
import script from "./IconSupport.vue?vue&type=script&lang=ts"
export * from "./IconSupport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__